import React, { createContext, useMemo, useState } from "react";
import { CollinsUser } from "../types/user";

export type CollinsUserContextType = {
  user?: CollinsUser;
  setUser: CallableFunction;
};

export const CollinsUserContext = createContext<CollinsUserContextType>({
  user: undefined,
  setUser: () => true
});

export const CollinsUserContextProvider = ({ children }: any) => {
  const [user, setUser] = useState<CollinsUser>();

  const contextValue = useMemo(
    () => ({
      user,
      setUser
    }),
    [user]
  );

  return (
    <CollinsUserContext.Provider value={contextValue}>
      {children}
    </CollinsUserContext.Provider>
  );
};
